import { paymentOptions } from '../const/paymentOptions';
import { isInstallmentLoan, isMonthly, isPN4, isSecuredInstallmentLoanProduct, isSetpayLegacyProduct } from './productTypeHelpers';
function serializePaymentOption(paymentOption, accountSummary) {
    const isEnrolledInCAP = accountSummary.billing.customerAssistancePlan;
    switch (paymentOption) {
        case paymentOptions.MONTHLY_PAYMENT:
        case paymentOptions.PN4_FIXED_PAYMENT_AMOUNT:
        case paymentOptions.MONTHLY_FIXED_PAYMENT_AMOUNT:
        case paymentOptions.MINIMUM_PAYMENT_DUE:
        case paymentOptions.NEW_MINIMUM_MONTHLY_DUE:
        case paymentOptions.SECURED_INSTALLMENT_FIXED_PAYMENT_AMOUNT:
            return isEnrolledInCAP ? 'NEW_MINIMUM_MONTHLY_DUE' : 'MINIMUM_PAYMENT_DUE';
        case paymentOptions.STATEMENT_BALANCE:
            return 'STATEMENT_BALANCE';
        case paymentOptions.WAIVED_INTEREST_AUTOPAY_AMOUNT:
            return 'WAIVED_INTEREST_AMOUNT';
        case paymentOptions.OTHER_PAYMENT:
        default:
            return 'USER_ENTERED_AMOUNT';
    }
}
const deserializeLoanPaymentOption = (productType) => {
    if (isPN4(productType)) {
        return paymentOptions.PN4_FIXED_PAYMENT_AMOUNT;
    }
    if (isMonthly(productType)) {
        return paymentOptions.MONTHLY_FIXED_PAYMENT_AMOUNT;
    }
    if (isSecuredInstallmentLoanProduct(productType)) {
        return paymentOptions.SECURED_INSTALLMENT_FIXED_PAYMENT_AMOUNT;
    }
    if (isSetpayLegacyProduct(productType)) {
        return paymentOptions.MONTHLY_PAYMENT;
    }
    throw new Error('Unknown loan product');
};
export function deserializePaymentOption(paymentOption, accountSummary) {
    const productType = accountSummary.product.type;
    switch (paymentOption) {
        case 'NEW_MINIMUM_MONTHLY_DUE':
            return paymentOptions.NEW_MINIMUM_MONTHLY_DUE;
        case 'MINIMUM_PAYMENT_DUE':
            return isInstallmentLoan(productType)
                ? deserializeLoanPaymentOption(productType)
                : paymentOptions.MINIMUM_PAYMENT_DUE;
        case 'WAIVED_INTEREST_AMOUNT':
            return paymentOptions.WAIVED_INTEREST_AUTOPAY_AMOUNT;
        case 'STATEMENT_BALANCE':
            return paymentOptions.STATEMENT_BALANCE;
        case 'USER_ENTERED_AMOUNT':
            return paymentOptions.OTHER_PAYMENT;
        default:
            return undefined;
    }
}
export const generateAutopayPayload = ({ paymentAmount, paymentOption, paymentMethod, accountSummary }) => {
    const payload = {
        enrollment: true,
        paymentOption: serializePaymentOption(paymentOption, accountSummary),
        paymentMethod: {
            id: paymentMethod
        }
    };
    if (paymentOption === paymentOptions.OTHER_PAYMENT) {
        payload.paymentAmount = Number(paymentAmount).toFixed(2);
    }
    return payload;
};
